import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons';
import HeaderIconLabel from 'components/UI/HeaderIconLabel';
import styles from './TaskAlert.module.scss';
interface Props {
    notificationAmount: number;
    onClick?: () => void;
}

export const TaskAlert: FunctionComponent<Props> = props => {
    return (
        <HeaderIconLabel text="Tasks">
            <div
                className={styles.badgeContainer}
                onClick={props.onClick}
            >
                <FontAwesomeIcon
                    icon={faClipboardList}
                    className={styles.icon}
                />
                {props.notificationAmount > 0 && <span className={styles.badge}>{props.notificationAmount}</span>}
            </div>
        </HeaderIconLabel>
    );
};

export default TaskAlert;
